import React, { useCallback } from 'react';
import { Send, Sparkles } from 'lucide-react';

interface ChatInputProps {
  value: string;
  onChange: (value: string) => void;
  onSend: () => void;
  isTyping: boolean;
}

export function ChatInput({ value, onChange, onSend, isTyping }: ChatInputProps) {
  const handleKeyPress = useCallback((e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      onSend();
    }
  }, [onSend]);

  return (
    <div className="relative p-3 border-t border-border backdrop-blur-sm">
      <div className="flex gap-2">
        <div className="flex-1 relative">
          <div className="absolute inset-0 bg-primary/20 rounded-lg blur-xl"></div>
          <input
            type="text"
            value={value}
            onChange={(e) => onChange(e.target.value)}
            onKeyPress={handleKeyPress}
            placeholder="Ask me anything..."
            className="relative w-full bg-muted/50 rounded-lg pl-8 pr-3 py-1.5 text-sm focus:outline-none focus:ring-2 focus:ring-primary placeholder-muted-foreground"
            disabled={isTyping}
          />
          <div className="absolute left-2 top-1/2 -translate-y-1/2">
            <div className="relative w-4 h-4 flex items-center justify-center">
              <Sparkles className="w-3 h-3 text-primary relative z-10" />
              <div className="absolute inset-0 animate-pulse bg-primary/50 blur-lg rounded-full" />
              <div className="absolute inset-0 bg-gradient-to-r from-primary/30 to-primary/30 animate-spin-slow rounded-full" />
            </div>
          </div>
        </div>

        <button
          onClick={onSend}
          disabled={!value.trim() || isTyping}
          className="theme-button p-2 rounded-lg shadow-lg shadow-primary/20 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          <Send className="w-5 h-5" />
        </button>
      </div>
    </div>
  );
}